import { render, staticRenderFns } from "./OffDaysTable.vue?vue&type=template&id=f07e872a&"
import script from "./OffDaysTable.vue?vue&type=script&lang=js&"
export * from "./OffDaysTable.vue?vue&type=script&lang=js&"
import style0 from "./OffDaysTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports